<template>
    <div id="promo-info-prev" class="promo-info-prev">
        <div class="promo-info-prev-content mx-auto">
            <Heading
                fullWidth
                title="CrossProm info"
                description="View the promotional content of your partner campaign to be shared in your update"
            />
            <div class="promo-info-prev-article py-3">
                <p id="promo-title" class="p3b c6">{{previewData.promo_title}}</p>
                <img id="promo-image"  :src="promoImage" class="w-100" alt="">
                <div class="mt-3">
                    <p id="promo-desc" class="p2n c7 white-space-pre-line">{{previewData.promo_desc}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Heading from "../../Theme/Heading";
    export default {
        name: "PromoInfoPrev",
        props: {
            previewData: Object
        },
        components: {
            Heading
        },
        computed: {
            promoImage(){
                return ((this.previewData.promo_image === this.previewData.image || !this.previewData.promo_image) && this.previewData.thumbnails && this.previewData.thumbnails.original) ? 
                        this.previewData.thumbnails.original :
                        this.previewData.promo_image
            }
        }
    }
</script>

<style scoped lang="scss">
    div.promo-info-prev {
        background: #FFFFFF;
        border: 1px solid #FFFFFF;

        div.promo-info-prev-content {
            width: 360px;
            padding-top: 38px;

            div.promo-info-prev-article {
                height: 485px;
                overflow-y: auto;
                border-top: 1px solid #F9F9F9;
                overflow-wrap: break-word;
            }
        }
    }
</style>